<template>
    <x-filter-tree :config="config" :datas="treeDatas"
        @filter="filterHandler"
    ></x-filter-tree>
</template>
<script setup>
import { watch, ref } from 'vue';
import { useRoute } from 'vue-router';
import XFilterTree from '../components/base/XFilterTree.vue';
import ModuleCenter from '../datamodule/ModuleCenter';

const route = useRoute()

const props = defineProps({
    config: { default: null },
    readonly: { default: false },
    data: { default: null },
    queryParams: { default: null },
    proxy: { default: null },
    filterData: { default: null },
    pcode: { default: null },
})
const getFilter = (filter)=> {
    if (!filter) return {query:{}, options:null};
    const query = {};
    const options = {};
    for (const [key, value] of Object.entries(filter)) {
        if (value instanceof Object && !(value instanceof Array)) {
            if (value.in) {
                query[key] = value.in.split(/\s*\.\s*/).reverse();
                options[key] = 'relate-in';
            } else if (value.not) {
                query[key] = value.not.split(/\s*\,\s*/).reverse();
                options[key] = 'notin';
            } else if (value.notin) {
                query[key] = value.notin.split(/\s*\.\s*/).reverse();
                options[key] = 'relate-notin';
            } else if (value.relate) {
                query[key] = value.relate;
                options[key] = 'multi-relate';
            }
        } else {
            query[key] = value;
        }
    }
    return {query:query, options:options};
}
const getQuery = (queryConfig, data)=> {
    if (!queryConfig) return {};
    const query = {};
    const options = {};
    queryConfig = queryConfig.replace(/([\w\,\.\:]+?)\?(?:\{(\w+)\}|([\w\'\"]+))/g, ($0, $1, $2, $3)=> {
        let keys = $1;
        let o = $2 || null;
        let ov = null;
        switch (o) {
            case null: ov = null; break;
            case 'loginUser': ov = token.userid; break;
            case 'loginUserName': ov = token.username; break;
            case 'now': ov = dayjs(TimeService.getServerTimeStamp()).format('YYYY-MM-DD HH:mm:ss'); break;
            default: ov = data[o];
        }
        const r = $3 != null ? $3.replace(/\'/g, '"') : null;
        let v = r != null ? JSON.parse(r) : ov;
        if (v == null) v = '';
        keys = keys.split(/[\,\.\:]/);
        let key = keys.shift();
        while(query[key]) key += '+';
        const value = [keys, ['' + v]];
        query[key] = value;
        options[key] = 'multi-relate';
        return '';
    })
    queryConfig = queryConfig.replace(/(\w+)(\=|\>|\<)(?:\{(\w+)\}|([\w\'\"]+))/g, ($0, $1, $c, $2, $3)=> {
        const c = $c;
        let key = $1;
        while(query[key]) key += '+';
        let o = $2 || null;
        let ov =  null;
        switch (o) {
            case null: ov = null; break;
            case 'loginUser': ov = token.userid; break;
            case 'loginUserName': ov = token.username; break;
            case 'now': ov = dayjs(TimeService.getServerTimeStamp()).format('YYYY-MM-DD HH:mm:ss'); break;
            default: ov = data[o];
        }
        const r = $3 != null ? $3.replace(/\'/g, '"') : null;
        let v = r != null ? JSON.parse(r) : ov;
        if (c == '=') {
            if (v != null) query[key] = v;
        } else if (c == '>') {
            if (v != null) {
                if (!query[key]) query[key] = [v, null];
                else query[key][0] = v;
            }
            options[key] = 'range';
        } else if (c == '<') {
            if (v != null) {
                if (!query[key]) query[key] = [null, v];
                else query[key][1] = v;
            }
            options[key] = 'range';
        }
        
        return '';
    })
    queryConfig = queryConfig.replace(/(\w+)\=([^\s\&]+)/g, ($0, $1, $2)=> {
        const key = $1
        let value = $2.split(/\s*\,\s*/);
        value = value.map((v)=>JSON.parse(v));
        if (value.length == 1) value = value[0];
        query[key] = value;
        return '';
    })
    return {query:query, options:options};
}
const pData = ref(null);
const keyData = ref(null);
watch(() => props.config, (value) => {
    keyData.value = value?.node?._parent?._data;
    pData.value = Object.assign({}, route.query, keyData.value);
    console.log(keyData.value)
}, { immediate: true, deep: true })

const getExtQuery = (relations, data) => {
    // 有部分内容需要和后端确认
    // 扩展通用跨表查询接口中查询条件中某天个字段， in 类型，增加 SQL 条件，如 (select ModuleC.bid from ModuleC where ModuleC.aid in (select ModuleA.aid from ModuleA where ModuleA.xxx = xxx))
    if (relations instanceof Array) {
        const query = [];
        for (const relation of relations) {
            query.push(Object.assign({}, relation, { value: relation.srcValue || (data ? data[relation.srcField] : null) }));
        }
        return query;
    } else {
        return Object.assign({}, relations, { value: data ? data[relations.srcField] : null });
    }
}
const extQueryParams = ref(null);
const treeDatas = ref(null);
const dataView = ref(null);

let loaded = false;
watch(() => keyData.value, async(value) => {
    // if (props.config?.node?._parent && value == null) return;
    const relations = props.config?.node?.getRelations();
    if (relations && value == null) return;
    if (value) {
        extQueryParams.value = getExtQuery(relations, value);
    }
    const f = getFilter(props.config?.treeFilter);
    const def = getQuery(props.config?.treeCondition, props.data);
    const queryParams = {query:Object.assign({}, f?.query, def?.query), options:Object.assign({}, f?.options, def?.options)};
    console.log('query datas');
    if (dataView.value) {
        loaded = true;
        const {data} = await dataView.value.queryDatas(queryParams, extQueryParams.value);
        // console.log('treeData', data)
        treeDatas.value = data;
    }
    // queryDatas();
}, { immediate: true })

if (props.filterData) {
    props.filterData.module = props.config?.view?.getModuleCode();
    props.filterData.withChildren = props.config?.withChildren;
}
const updateView = async ()=> {
    console.log('query tree data');
    if (!loaded && dataView.value) {
        loaded = true;
        
        const relations = props.config?.node?.getRelations();
        if (relations && keyData.value == null) return;
        if (keyData.value) {
            extQueryParams.value = getExtQuery(relations, keyData.value);
        }
        const f = getFilter(props.config?.treeFilter);
        const def = getQuery(props.config?.treeCondition, props.data);
        const queryParams = {query:Object.assign({}, f?.query, def?.query), options:Object.assign({}, f?.options, def?.options)};
        console.log('query datas');
        if (dataView.value) {
            loaded = true;
            const {data} = await dataView.value.queryDatas(queryParams, extQueryParams.value);
            // console.log('treeData', data)
            treeDatas.value = data;
        }
    }
}

watch(()=>props.filterData?._t, (value)=> {
    loaded = false;
    updateView();
})
watch(() => props.config?.view, async (value) => {
    dataView.value = value;
    await updateView();
}, { immediate: true })

const getTreeValues = (data, field, res)=> {
    if (!res) res = [];
    res.push(data[field]);
    if (data.children) {
        for (const child of data.children) {
            getTreeValues(child, field, res);
        }
    }
    return res;
}
const getValue = (data, field)=> {
    if (props.config?.withChildren) {
        return getTreeValues(data, field);
    } else {
        return data[field]
    }
}
const toStringArray = (value)=> {
    if (!value) return [];
    if (value instanceof Array) {
        return value.map((v)=> {
            if (!v) return '';
            return '' + v;
        })
    } else {
        return ['' + value];
    }
}

const filterHandler = (filter)=> {
    // console.log(props,filter);
    if (props.filterData) props.filterData.data = Object.assign({}, filter);
    const path = [dataView.value.getModuleCode(), props.config.targetModule];
    const relations = ModuleCenter.testRelations(path);
    if (relations.length > 1) {
        const p = [];
        for (let i = 0; i < relations.length - 1; i++) {
            const {dest} = relations[i];
            const {src} = relations[i + 1];
            let srcField = null;
            let module = null;
            let destField = null;
            dest.replace(/^(\w+)\.(\w+)$/, ($0, $1, $2)=> {
                module = $1;
                srcField = $2;
            })
            src.replace(/^\w+\.(\w+)$/, ($0, $1)=> {
                destField = $1;
            })
            p.push(destField);
            p.push(module);
            p.push(srcField);
        }
        let field = '';
        let key = '';
        relations[0].src.replace(/^\w+\.(\w+)$/, ($0, $1)=> {
            field = $1;
        })
        relations[relations.length - 1].dest.replace(/^\w+\.(\w+)$/, ($0, $1)=> {
            key = $1;
        })
        const v = getValue(filter, field);
        if (v == null) {
            delete props.filterData.data[field];
            delete props.queryParams.query[key];
            if (props.queryParams.options) delete props.queryParams.options[key];
        } else {
            props.queryParams.query[key] = [p, toStringArray(v)];
            if (!props.queryParams.options) props.queryParams.options = {};
            props.queryParams.options[key] = 'multi-relate';
        }
    } else if (relations.length == 1) {
        let field = '';
        let key = '';
        relations[0].src.replace(/^\w+\.(\w+)$/, ($0, $1)=> {
            field = $1;
        })
        relations[relations.length - 1].dest.replace(/^\w+\.(\w+)$/, ($0, $1)=> {
            key = $1;
        })
        const v = getValue(filter, field);
        if (v == null) {
            delete props.filterData.data[field];
            delete props.queryParams.query[key];
        } else {
            props.queryParams.query[key] = v;
        }
    } else {
        const module = dataView.value.getModule();
        const relation = module.getModuleRelation(module.getCode());
        if (relation) {
            props.queryParams.query[relation.destField] = filter[relation.srcField];
        } else {
            for (const [k, v] of Object.entries(filter)) {
                props.queryParams.query[k] = getValue(filter, k);
            }
        }
    }
    for (let i in props.filterData.data) {
        return;
    }
    props.filterData.data = null;
        // console.log(props.queryParams);
}

const getFilterTreeDatas = ()=> {
    return null;
}
</script>